import { render, staticRenderFns } from "./bnrs.vue?vue&type=template&id=0fbfc549&scoped=true&lang=pug&"
import script from "./bnrs.vue?vue&type=script&lang=js&"
export * from "./bnrs.vue?vue&type=script&lang=js&"
import style0 from "./bnrs.vue?vue&type=style&index=0&id=0fbfc549&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfc549",
  null
  
)

export default component.exports